/* ============================================================
   CustomSolo Theme — global behaviours
   Sections communicate through data-attributes only, so any
   section can be re-ordered / removed without breaking others.
   ============================================================ */
(function () {
  'use strict';

  var CS = window.CS = window.CS || {};

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  /* ---------- 1. Mobile navigation drawer ---------- */
  function initMobileNav() {
    var burgers = $$('[data-cs-burger]');
    var panels = $$('[data-cs-mobile-nav]');
    if (!burgers.length || !panels.length) return;

    function setOpen(open) {
      burgers.forEach(function (b) { b.classList.toggle('is-active', open); b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      panels.forEach(function (p) { p.classList.toggle('is-open', open); p.setAttribute('aria-hidden', open ? 'false' : 'true'); });
      document.documentElement.classList.toggle('cs-nav-open', open);
    }

    burgers.forEach(function (b) {
      on(b, 'click', function (e) {
        e.preventDefault();
        setOpen(!document.documentElement.classList.contains('cs-nav-open'));
      });
    });

    $$('[data-cs-mobile-nav-close]').forEach(function (c) {
      on(c, 'click', function (e) { e.preventDefault(); setOpen(false); });
    });

    // close when a link is tapped
    $$('[data-cs-mobile-nav] a').forEach(function (a) { on(a, 'click', function () { setOpen(false); }); });

    // close on Escape
    on(document, 'keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  /* ---------- 2. Mega menu ---------- */
  /* Panels are fixed-position sections rendered outside <header>, so they
     need the header's live bottom edge to sit flush under it. */
  function syncHeaderHeight() {
    var header = $('.cs-header');
    if (!header) return;
    var bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--cs-header-h', bottom + 'px');
  }

  function initMegaMenu() {
    var triggers = $$('[data-cs-mega]');
    var panels = $$('[data-cs-mega-panel]');
    if (!triggers.length || !panels.length) return;

    /* The glass backdrop is a sibling of the panel. It must start exactly at
       the panel's bottom edge, so we pin it in px (the panel height varies
       with content) and refresh it whenever the header height changes. */
    function backdropFor(panel) {
      var scope = panel.parentElement || document;
      return scope.querySelector('[data-cs-mega-backdrop]');
    }
    function backdropTop(panel) {
      var header = $('.cs-header');
      var hb = header ? header.getBoundingClientRect().bottom : 96;
      return Math.round(hb + panel.offsetHeight);
    }
    function syncBackdrop() {
      panels.forEach(function (p) {
        var bd = backdropFor(p);
        if (!bd) return;
        if (!p.classList.contains('is-open')) return;
        bd.style.top = backdropTop(p) + 'px';
      });
    }

    syncHeaderHeight();
    var syncRaf = null;
    function scheduleSync() {
      if (syncRaf) return;
      syncRaf = requestAnimationFrame(function () { syncRaf = null; syncHeaderHeight(); syncBackdrop(); });
    }
    on(window, 'resize', scheduleSync);
    on(window, 'scroll', scheduleSync);
    on(window, 'load', scheduleSync);

    var openTimer = null;
    var current = null;

    function close() {
      panels.forEach(function (p) {
        p.classList.remove('is-open');
        p.setAttribute('aria-hidden', 'true');
        var bd = backdropFor(p);
        if (bd) bd.classList.remove('is-visible');
      });
      triggers.forEach(function (t) { t.classList.remove('is-open'); t.setAttribute('aria-expanded', 'false'); });
      current = null;
    }
    function open(key) {
      if (current === key) return;
      close();
      var panel = $('[data-cs-mega-panel="' + key + '"]');
      var trigger = $('[data-cs-mega="' + key + '"]');
      if (!panel) return;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      var bd = backdropFor(panel);
      if (bd) {
        syncHeaderHeight();
        bd.style.top = backdropTop(panel) + 'px';
        bd.classList.add('is-visible');
      }
      if (trigger) { trigger.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
      current = key;
    }

    triggers.forEach(function (t) {
      var key = t.getAttribute('data-cs-mega');
      on(t, 'mouseenter', function () { clearTimeout(openTimer); open(key); });
      on(t, 'focus', function () { clearTimeout(openTimer); open(key); });
      on(t, 'mouseleave', function () { openTimer = setTimeout(close, 180); });
      on(t, 'click', function (e) {
        if (t.tagName === 'A' && t.getAttribute('href') === '#') { e.preventDefault(); open(key); }
      });
    });

    panels.forEach(function (p) {
      on(p, 'mouseenter', function () { clearTimeout(openTimer); });
      on(p, 'mouseleave', function () { openTimer = setTimeout(close, 180); });
    });

    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });
    on(document, 'click', function (e) {
      if (current && !e.target.closest('[data-cs-mega]') && !e.target.closest('[data-cs-mega-panel]')) close();
    });
  }

  /* ---------- 3. Hero carousel (gift-hero: image + card stack + dots) ---------- */
  function initHeroCarousel() {
    $$('[data-cs-hero-carousel]').forEach(function (carousel) {
      var visual = carousel.parentElement;
      if (!visual) return;
      var slides = $$('[data-cs-hero-slide]', carousel);
      var cards = $$('[data-cs-hero-card]', visual);
      var dotsWrap = $('[data-cs-hero-dots]', visual);
      var dots = dotsWrap ? $$('button', dotsWrap) : [];
      if (slides.length < 2) {
        slides.forEach(function (s) { s.classList.add('is-active'); });
        cards.forEach(function (c, n) { c.classList.toggle('is-active', n === 0); });
        return;
      }

      var idx = 0;
      var timer = null;

      function show(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
        cards.forEach(function (c, n) { c.classList.toggle('is-active', n === idx); });
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === idx);
          d.setAttribute('aria-current', n === idx ? 'true' : 'false');
        });
      }
      function restart() {
        if (timer) clearInterval(timer);
        timer = setInterval(function () { show(idx + 1); }, 5000);
      }
      function stop() { if (timer) clearInterval(timer); }

      dots.forEach(function (d, i) {
        on(d, 'click', function () { show(i); restart(); });
      });

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      show(0);
      if (!reduce) {
        on(visual, 'mouseenter', stop);
        on(visual, 'mouseleave', restart);
        restart();
      }
    });
  }

  /* ---------- 3b. Endless entertainment full-bleed carousels (per rail) ---------- */
  function initEndlessCarousel() {
    $$('[data-cs-endless2-viewport]').forEach(function (viewport) {
      var rail = viewport.closest('[data-cs-endless2-rail]') || document;
      var track = viewport.firstElementChild;
      var dotsWrap = $('[data-cs-endless2-dots]', rail);
      var pauseBtn = $('[data-cs-endless2-pause]', rail);
      if (!track) return;
      var cards = $$('.customsolo-endless2__card', track);
      if (!cards.length) return;

      var page = 0;
      var pages = 1;
      var timer = null;
      var paused = false;

      function metrics() {
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        var cw = cards[0].getBoundingClientRect().width;
        var per = Math.max(1, Math.round((viewport.clientWidth + gap) / (cw + gap)));
        var centered = track.classList.contains('customsolo-endless2__track--tv');
        var step = centered ? 1 : per;
        var p = centered ? cards.length : Math.max(1, Math.ceil(cards.length / per));
        return { gap: gap, cw: cw, per: per, step: step, pages: p };
      }

      function buildDots() {
        var m = metrics();
        pages = m.pages;
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          if (i === page) b.classList.add('is-active');
          on(b, 'click', function (ev) {
            var btn = ev.currentTarget;
            var all = $$('button', dotsWrap);
            go(all.indexOf(btn));
          });
          dotsWrap.appendChild(b);
        }
      }

      function go(i) {
        var m = metrics();
        pages = m.pages;
        page = ((i % pages) + pages) % pages;
        var maxOffset = Math.max(0, track.scrollWidth - viewport.clientWidth);
        var target = Math.min(page * m.step * (m.cw + m.gap), maxOffset);
        track.style.transform = 'translateX(' + (-target) + 'px)';
        if (dotsWrap) {
          $$('button', dotsWrap).forEach(function (d, n) { d.classList.toggle('is-active', n === page); });
        }
      }
      function restart() {
        if (timer) clearInterval(timer);
        if (paused) return;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) return;
        timer = setInterval(function () { go(page + 1); }, 3500);
      }

      if (pauseBtn) {
        on(pauseBtn, 'click', function () {
          paused = !paused;
          pauseBtn.classList.toggle('is-paused', paused);
          pauseBtn.setAttribute('aria-label', paused ? 'Play carousel' : 'Pause carousel');
          if (paused) { if (timer) clearInterval(timer); }
          else restart();
        });
      }

      on(viewport, 'mouseenter', function () { if (timer) clearInterval(timer); });
      on(viewport, 'mouseleave', restart);
      on(document, 'visibilitychange', function () {
        if (document.hidden) { if (timer) clearInterval(timer); } else restart();
      });
      on(window, 'resize', function () { buildDots(); go(page); });

      track.style.transition = 'transform .6s ease';
      track.style.willChange = 'transform';
      buildDots();
      go(0);
      restart();
    });
  }

  /* ---------- 4. Collection tabs (horizontal scroller) ---------- */
  function initCollectionTabs() {
    $$('[data-cs-tabs]').forEach(function (wrap) {
      var id = wrap.getAttribute('data-cs-tabs');
      var scroller = $('[data-cs-tabs-scroller="' + id + '"]');
      var tabs = $$('[data-cs-tab]', wrap);
      if (!scroller || !tabs.length) return;

      tabs.forEach(function (t) {
        on(t, 'click', function () {
          tabs.forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-selected', 'false'); });
          t.classList.add('active');
          t.setAttribute('aria-selected', 'true');
          var target = $('[data-cs-tab-panel="' + t.getAttribute('data-cs-tab') + '"]', scroller);
          if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      });
    });
  }

  /* ---------- 5. Made-from-your-story live preview ---------- */
  function initStoryStudio() {
    $$('[data-cs-studio]').forEach(function (root) {
      var nameInput = $('[data-cs-studio-name]', root);
      var msgInput = $('[data-cs-studio-msg]', root);
      var outName = $('[data-cs-studio-out-name]', root);
      var outMsg = $('[data-cs-studio-out-msg]', root);
      if (nameInput && outName) {
        on(nameInput, 'input', function () { outName.textContent = nameInput.value || outName.getAttribute('data-cs-placeholder'); });
      }
      if (msgInput && outMsg) {
        on(msgInput, 'input', function () { outMsg.textContent = msgInput.value || outMsg.getAttribute('data-cs-placeholder'); });
      }
    });
  }

  /* ---------- 6. Cart drawer ---------- */
  CS.cart = {
    open: function () {
      var drawer = $('[data-cs-cart-drawer]');
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cs-cart-open');
      this.refresh();
    },
    close: function () {
      var drawer = $('[data-cs-cart-drawer]');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cs-cart-open');
    },
    add: function (variantId, qty) {
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
      }).then(function (r) { return r.json(); }).then(function () { CS.cart.open(); });
    },
    change: function (line, qty) {
      return fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () { CS.cart.refresh(); });
    },
    refresh: function () {
      var drawer = $('[data-cs-cart-drawer]');
      if (!drawer) return;
      fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { CS.cart.render(cart); })
        .catch(function () { });
    },
    render: function (cart) {
      var drawer = $('[data-cs-cart-drawer]');
      if (!drawer) return;
      var body = $('[data-cs-cart-body]', drawer);
      var count = $('[data-cs-cart-count]', drawer);
      var total = $('[data-cs-cart-total]', drawer);
      if (count) { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }
      if (total && window.CSFormatMoney) total.innerHTML = window.CSFormatMoney(cart.total_price);
      if (!body) return;
      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<p class="cs-cart__empty">' + (drawer.getAttribute('data-cs-empty-text') || 'Your cart is empty.') + '</p>';
        return;
      }
      body.innerHTML = cart.items.map(function (it, i) {
        var img = it.featured_image && it.featured_image.url ? it.featured_image.url : (it.image || '');
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        var vals = [];
        if (it.properties) {
          for (var k in it.properties) {
            if (!Object.prototype.hasOwnProperty.call(it.properties, k)) continue;
            if (k.charAt(0) === '_' && k !== '_Name' && k !== '_Date') continue;
            var val = it.properties[k];
            if (!val || String(val).length > 120) continue;
            vals.push(String(val));
          }
        }
        var lines = vals.length ? vals.slice(0, 3).join('<br>') : '';
        var money = window.CSFormatMoney ? window.CSFormatMoney(it.final_line_price) : '';
        var url = it.url || (it.handle ? '/products/' + it.handle : '/cart');
        return '' +
          '<div class="customsolo-drawer-item">' +
          '<div class="customsolo-drawer-item__media">' + (img ? '<img src="' + img.replace(/(\.[a-z]+)(_\d+x\d*)?(\.progressive)?(\.[a-z]+)?$/i, '$1') + '" alt="' + (it.product_title || '') + '" loading="lazy">' : '') + '</div>' +
          '<div>' +
          '<div class="customsolo-confirm-row"><strong>' + it.product_title + '</strong><b>' + money + '</b></div>' +
          (variant ? '<p>' + variant + '</p>' : '') +
          (lines ? '<p>' + lines + '</p>' : '') +
          '<a class="customsolo-drawer-view" href="' + url + '">View design</a>' +
          '</div>' +
          '</div>';
      }).join('') +
      '<div class="customsolo-confirm-context"><h3>Your bag &#183; ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + '</h3></div>';
    }
  };

  function initCartDrawer() {
    $$('[data-cs-cart-open]').forEach(function (b) {
      on(b, 'click', function (e) { e.preventDefault(); CS.cart.open(); });
    });
    $$('[data-cs-cart-close]').forEach(function (b) {
      on(b, 'click', function (e) { e.preventDefault(); CS.cart.close(); });
    });
    var drawer = $('[data-cs-cart-drawer]');
    if (!drawer) return;
    // close on overlay click & Escape
    on(drawer, 'click', function (e) { if (e.target === drawer) CS.cart.close(); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') CS.cart.close(); });
    // update the header badge on load
    if (window.routes && window.routes.cart_url) {
      fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $$('[data-cs-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
        }).catch(function () { });
    }
  }

  /* ---------- 2.5 sticky header glass scroll state ---------- */
  function initStickyHeader() {
    var header = $('[data-cs-sticky-header]');
    if (!header) return;
    var ticking = false;
    var last = false;
    function update() {
      var scrolled = (window.scrollY || window.pageYOffset || 0) > 8;
      if (scrolled !== last) {
        header.classList.toggle('is-scrolled', scrolled);
        last = scrolled;
      }
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', onScroll, { passive: true });
    update();
  }

  /* ---------- boot ---------- */
  function boot() {
    syncHeaderHeight();
    initStickyHeader();
    initMobileNav();
    initMegaMenu();
    initHeroCarousel();
    initEndlessCarousel();
    initCollectionTabs();
    initStoryStudio();
    initCartDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ============================================================
   CustomSolo Theme — collection / product / cart templates
   Second IIFE: everything is delegated on `document`, so sections
   can be re-ordered, duplicated or removed without re-binding.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    if (typeof window.CSFormatMoney === 'function') return window.CSFormatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- collection: sort dropdown ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-cs-sortby]');
    if (!sel) return;
    var base = sel.getAttribute('data-base-url') || window.location.pathname;
    var url = base + '?sort_by=' + encodeURIComponent(sel.value);
    window.location.href = url;
  });

  /* ---------- product: gallery thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-cs-gallery-thumb]');
    if (!thumb) return;
    var wrap = thumb.closest('[data-cs-gallery]');
    var main = $('[data-cs-gallery-main]', wrap);
    if (!main) return;
    var full = thumb.getAttribute('data-full');
    if (full) main.setAttribute('src', full);
    $$('[data-cs-gallery-thumb]', wrap).forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  });

  /* ---------- product: variant pills ---------- */
  function readVariants() {
    var node = $('[data-cs-variants]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (err) { return null; }
  }

  function syncVariant() {
    var form = $('[data-cs-product-form]');
    if (!form) return;
    var variants = readVariants();
    var hiddenId = $('[data-cs-variant-id]', form);
    var priceEl = $('[data-cs-price]');
    if (!variants || !variants.length || !hiddenId) return;

    var selected = [];
    $$('[data-cs-option]', form).forEach(function (group) {
      var i = +group.getAttribute('data-cs-option');
      var checked = $('input[data-cs-option-input="' + i + '"]:checked', group);
      selected[i - 1] = checked ? checked.value : null;
    });

    var match = null;
    variants.forEach(function (v) {
      var ok = selected.every(function (val, idx) {
        return val === null || String(v['option' + (idx + 1)]) === String(val);
      });
      if (ok && !match) match = v;
    });

    if (match) {
      hiddenId.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cs-option-input]');
    if (!input) return;
    var group = input.closest('[data-cs-option]') || input.closest('.cs-opt');
    $$('.cs-opt__btn', group).forEach(function (b) { b.classList.remove('active'); });
    var label = input.closest('.cs-opt__btn');
    if (label) label.classList.add('active');
    syncVariant();
  });

  /* ---------- product: demo option pills (no live product) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cs-option-demo] .cs-opt__btn');
    if (!btn) return;
    var row = btn.closest('[data-cs-option-demo]');
    $$('.cs-opt__btn', row).forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
  });

  /* ---------- quantity stepper (product page) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cs-qty] button');
    if (!btn) return;
    var wrap = btn.closest('[data-cs-qty]');
    var out = $('[data-cs-qty-value]', wrap);
    if (!out) return;
    var val = parseInt(out.textContent, 10) || 1;
    if (btn.hasAttribute('data-cs-qty-dec')) val = Math.max(1, val - 1);
    else if (btn.hasAttribute('data-cs-qty-inc')) val = val + 1;
    out.textContent = val;
    var input = $('[data-cs-qty-input]');
    if (input) input.value = val;
  });

  /* ---------- accordion ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.cs-acc__head');
    if (!head) return;
    var item = head.closest('.cs-acc__item');
    var icon = $('.cs-acc__icon', head);
    var open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (icon) icon.innerHTML = open ? '&minus;' : '+';
  });

  /* ---------- cart page ---------- */
  function cartPageRefresh() {
    if (!window.routes || !window.routes.cart_url) return Promise.resolve();
    return fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartPage(cart); })
      .catch(function () { });
  }

  function renderCartPage(cart) {
    var hasItems = cart.item_count > 0;

    var itemsEl = $('[data-cs-cart-items]');
    var sumEl = $('[data-cs-cart-summary]');
    var emptyEl = $('[data-cs-cart-empty]');
    var itemsDemo = itemsEl && itemsEl.getAttribute('data-cs-demo') === 'true';
    var sumDemo = sumEl && sumEl.getAttribute('data-cs-demo') === 'true';

    if (itemsEl) itemsEl.hidden = !hasItems && !itemsDemo;
    if (sumEl) sumEl.hidden = !hasItems && !sumDemo;
    if (emptyEl) emptyEl.hidden = hasItems || itemsDemo;

    if (hasItems) {
      var subtotal = $('[data-cs-subtotal]');
      var total = $('[data-cs-cartpage-total]');
      if (subtotal) subtotal.textContent = money(cart.total_price);
      if (total) total.textContent = money(cart.total_price);
    }

    var countEl = $('[data-cs-cartpage-count]');
    if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cs-line-dec], [data-cs-line-inc], [data-cs-line-remove]');
    if (!btn) return;
    var line = btn.closest('[data-cs-cart-line]');
    if (!line) return;

    var key = line.getAttribute('data-key');
    var out = $('[data-cs-line-qty]', line);
    var current = parseInt(out ? out.textContent : '1', 10) || 1;
    var qty = current;
    if (btn.hasAttribute('data-cs-line-dec')) qty = Math.max(0, current - 1);
    else if (btn.hasAttribute('data-cs-line-inc')) qty = current + 1;
    else qty = 0;

    if (!key) {
      // Demo row (server had no line items): update locally only.
      if (qty === 0) { line.remove(); return; }
      if (out) out.textContent = qty;
      return;
    }

    if (window.CS && window.CS.cart && typeof window.CS.cart.change === 'function') {
      btn.disabled = true;
      window.CS.cart.change(key, qty)
        .then(function () { window.location.reload(); })
        .catch(function () { btn.disabled = false; window.location.reload(); });
    }
  });

  if (window.location.pathname.indexOf('/cart') === 0) {
    cartPageRefresh();
  }
})();

/* === Family Gifts PLP (d01) ============================================ */
(function () {
  'use strict';

  // ---- Gallery (collection-gallery.js) -----------------------------------
  function initGallery(root) {
    var galleries = root.querySelectorAll('[data-card-gallery]');
    galleries.forEach(function (gallery) {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      var card = gallery.closest('.customsolo-d01-card');
      var track = gallery.querySelector('.customsolo-d01-gallery__track');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('.customsolo-d01-gallery__slide'));
      var previous = gallery.querySelector('[data-gallery-direction="previous"]');
      var next = gallery.querySelector('[data-gallery-direction="next"]');
      var status = gallery.querySelector('[role="status"]');
      var storage = (function () { try { return window.sessionStorage; } catch (e) { return null; } })();
      var key = 'customsolo.card-view.v1:' + (window.location.pathname || '') + ':' + (gallery.getAttribute('aria-label') || '');
      var index = -1;
      var gesture = null;
      var suppressClickUntil = 0;

      function nextIndex(idx, delta, count) { return Math.max(0, Math.min(count - 1, idx + delta)); }
      function select(requested, remember) {
        var selected = Number.isInteger(requested) ? nextIndex(0, requested, slides.length) : 0;
        if (selected === index) return;
        index = selected;
        if (remember !== false) { try { if (storage) storage.setItem(key, String(index)); } catch (e) {} }
        if (track) track.style.transform = 'translateX(' + (-index * 100) + '%)';
        slides.forEach(function (s, i) { s.setAttribute('aria-hidden', String(i !== index)); });
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
        if (status) status.textContent = slides[index].dataset.galleryLabel + ', image ' + (index + 1) + ' of ' + slides.length;
        if (document.activeElement === previous && previous.disabled) next.focus({preventScroll: true});
        if (document.activeElement === next && next.disabled) previous.focus({preventScroll: true});
      }
      var saved = 0; try { saved = Number((storage && storage.getItem(key)) || 0); } catch (e) {}
      select(saved, false);

      [previous, next].forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (!button.disabled) select(index + (button === next ? 1 : -1));
        });
      });
      gallery.addEventListener('keydown', function (event) {
        if (['ArrowLeft','ArrowRight','Home','End'].indexOf(event.key) === -1) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.key === 'Home') select(0);
        else if (event.key === 'End') select(slides.length - 1);
        else select(index + (event.key === 'ArrowRight' ? 1 : -1));
      });

      if (card) {
        card.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'mouse' || event.isPrimary === false || event.target.closest('button')) return;
          var rect = gallery.getBoundingClientRect();
          if (event.clientY < rect.top || event.clientY > rect.bottom || event.clientX < rect.left || event.clientX > rect.right) return;
          gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false };
        });
        card.addEventListener('pointermove', function (event) {
          if (!gesture || gesture.id !== event.pointerId) return;
          var dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
          if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) * 1.25) {
            gesture.moved = true;
            try { card.setPointerCapture(event.pointerId); } catch (e) {}
            if (event.cancelable) event.preventDefault();
          }
        });
        card.addEventListener('pointerup', function (event) {
          if (!gesture || gesture.id !== event.pointerId) return;
          var dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
          var delta = (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.25) ? (dx < 0 ? 1 : -1) : 0;
          if (gesture.moved || delta) suppressClickUntil = Date.now() + 500;
          if (delta) select(index + delta);
          gesture = null;
        });
        card.addEventListener('pointercancel', function () { gesture = null; });
        card.addEventListener('click', function (event) {
          if (Date.now() < suppressClickUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
      }
    });
  }

  // ---- Mobile dialog (collection-mobile.js) ------------------------------
  function initMobile(root) {
    var filters = Array.prototype.slice.call(root.querySelectorAll('.customsolo-d01-filter'));
    if (!filters.length || typeof window.HTMLDialogElement === 'undefined') return;
    var mobile = window.matchMedia('(max-width:639px)');
    var sheet = document.createElement('dialog');
    sheet.className = 'customsolo-d01 d01-mobile-sheet';
    sheet.setAttribute('aria-labelledby', 'd01-sheet-title');
    sheet.innerHTML = '<div class="d01-mobile-sheet__header"><h2 id="d01-sheet-title"></h2><button type="button" class="d01-mobile-sheet__close" aria-label="Close filters"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.7"></svg></button></div>';
    document.body.appendChild(sheet);
    var active = null;
    function close() {
      if (!active) return;
      var details = active.details, placeholder = active.placeholder, summary = active.summary;
      active = null;
      details.open = false;
      if (placeholder && placeholder.parentNode) placeholder.parentNode.replaceChild(details, placeholder);
      if (sheet.open) sheet.close();
      document.documentElement.classList.remove('d01-sheet-open');
      if (summary) summary.focus({preventScroll: true});
    }
    filters.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) { if (active && active.details === details) close(); return; }
        if (!mobile.matches || (active && active.details === details)) return;
        close();
        var summary = details.querySelector('summary');
        var placeholder = document.createElement('div');
        var rect = summary.getBoundingClientRect();
        placeholder.style.height = rect.height + 'px';
        details.parentNode.replaceChild(placeholder, details);
        active = { details: details, placeholder: placeholder, summary: summary };
        sheet.querySelector('h2').textContent = details.dataset.sortGroup !== undefined ? 'Sort by' : (summary.querySelector('.customsolo-d01-control__label') || {}).textContent || '';
        sheet.appendChild(details);
        document.documentElement.classList.add('d01-sheet-open');
        sheet.showModal();
        sheet.querySelector('.d01-mobile-sheet__close').focus({preventScroll: true});
      });
    });
    sheet.querySelector('button').addEventListener('click', close);
    sheet.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    sheet.addEventListener('click', function (e) { if (e.target === sheet) close(); });
    var breakpoint = function () { if (!mobile.matches) close(); };
    mobile.addEventListener('change', breakpoint);
  }

  // ---- Filters + sort (client-side) --------------------------------------
  function initFilters(root) {
    var toolbar = root.querySelector('.customsolo-d01-toolbar');
    var grid = root.querySelector('[data-d01-grid-items]');
    var countEl = root.querySelector('[data-d01-count]');
    if (!toolbar || !grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-d01-card]'));

    var state = { groupValues: {}, sort: null };

    function getCardPrice(card) { return parseFloat(card.getAttribute('data-price') || '0') || 0; }
    function getCardType(card) { return card.getAttribute('data-product-type') || ''; }
    function getCardPers(card) {
        var raw = card.getAttribute('data-personalization') || '[]';
        try { return JSON.parse(raw); } catch (e) { return []; }
      }

    function priceMatches(card, option) {
      var price = getCardPrice(card);
      var min = option.getAttribute('data-price-min');
      var max = option.getAttribute('data-price-max');
      if (min !== null && price < parseFloat(min)) return false;
      if (max !== null && max !== '' && price > parseFloat(max)) return false;
      return true;
    }

    function cardMatches(card) {
      var groups = Object.keys(state.groupValues);
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        var opts = state.groupValues[g];
        if (!opts.length) continue;
        var matched = false;
        for (var j = 0; j < opts.length; j++) {
          var optionEl = opts[j];
          var key = g;
          if (key === 'price') {
            if (priceMatches(card, optionEl)) { matched = true; break; }
          } else if (key === 'product-type') {
            if (getCardType(card) === optionEl.getAttribute('data-filter-option')) { matched = true; break; }
          } else if (key === 'personalization') {
            var pers = getCardPers(card);
            if (pers.indexOf(optionEl.getAttribute('data-filter-option')) !== -1) { matched = true; break; }
          }
        }
        if (!matched) return false;
      }
      return true;
    }

    function sortCards(visible) {
      if (!state.sort) return visible;
      var sorted = visible.slice();
      if (state.sort === 'price-asc') sorted.sort(function (a, b) { return getCardPrice(a) - getCardPrice(b); });
      else if (state.sort === 'price-desc') sorted.sort(function (a, b) { return getCardPrice(b) - getCardPrice(a); });
      else if (state.sort === 'newest') sorted.sort(function (a, b) { return (b.getAttribute('data-newest') || '').localeCompare(a.getAttribute('data-newest') || ''); });
      return sorted;
    }

    function apply() {
      var matched = cards.filter(cardMatches);
      var visible = sortCards(matched);
      cards.forEach(function (c) { c.style.display = 'none'; });
      visible.forEach(function (c) { c.style.display = ''; });
      if (countEl) {
        var labelBase = (countEl.textContent || '').replace(/^\d+/, '');
        countEl.textContent = visible.length + labelBase.replace(/[0-9]+/g, '').replace(/^\s*$/, '') || (visible.length + ' gifts');
      }
      Object.keys(state.groupValues).forEach(function (g) {
        var badge = toolbar.querySelector('[data-filter-group="' + g + '"] [data-d01-badge]');
        if (badge) {
          var n = state.groupValues[g].length;
          badge.hidden = n === 0;
          badge.textContent = String(n);
        }
      });
    }

    // Bind filter option clicks
    toolbar.querySelectorAll('[data-filter-option]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var group = btn.getAttribute('data-filter-key') || btn.closest('[data-filter-group]').getAttribute('data-filter-group');
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', String(!pressed));
        state.groupValues[group] = state.groupValues[group] || [];
        if (pressed) {
          state.groupValues[group] = state.groupValues[group].filter(function (b) { return b !== btn; });
        } else {
          state.groupValues[group].push(btn);
        }
        apply();
      });
    });

    // Clear button per filter group
    toolbar.querySelectorAll('[data-filter-clear]').forEach(function (clearBtn) {
      clearBtn.addEventListener('click', function (event) {
        event.preventDefault();
        var details = clearBtn.closest('[data-filter-group]');
        if (!details) return;
        var group = details.getAttribute('data-filter-group');
        if (state.groupValues[group]) {
          state.groupValues[group].forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          state.groupValues[group] = [];
        }
        apply();
      });
    });

    // Sort option clicks
    toolbar.querySelectorAll('[data-sort-option]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var value = btn.getAttribute('data-sort-option');
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        toolbar.querySelectorAll('[data-sort-option]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        if (!pressed) {
          btn.setAttribute('aria-pressed', 'true');
          state.sort = value;
        } else {
          state.sort = null;
        }
        apply();
      });
    });

    toolbar.querySelectorAll('[data-sort-clear]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        state.sort = null;
        toolbar.querySelectorAll('[data-sort-option]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        apply();
      });
    });

    apply();
  }

  // ---- Boot --------------------------------------------------------------
  function boot() {
    var root = document.body;
    if (!root.classList.contains('customsolo-d01-route')) return;
    initGallery(root);
    initMobile(root);
    initFilters(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* HEADER CART BADGE SYNC (MFL 1:1) — 2026-09-16
   CS.cart.render only updated the drawer-scoped count; the header badge
   ([data-cs-cart-count] in the header section) never refreshed. Wrap
   render so every badge updates, and refresh once on load. */
(function () {
  if (!window.CS || !CS.cart || !CS.cart.render) return;
  var base = CS.cart.render.bind(CS.cart);
  CS.cart.render = function (cart) {
    base(cart);
    var badges = document.querySelectorAll('[data-cs-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
      badges[i].hidden = cart.item_count === 0;
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { CS.cart.refresh(); });
  } else { CS.cart.refresh(); }
})();
